import React from 'react';
import {Button, Modal, ModalBody, ModalFooter} from 'reactstrap';
import {Link} from 'react-router-dom';
import {get} from 'lodash';
import cx from 'classnames';
import {ACCOUNT_ROLES, RENEWAL_IMAGES} from 'configs';
import MuiIcon from 'components/Icons/MuiIcon';
import useManageSubscription from '../useManageSubscription';
import {useAuth} from 'contexts/AuthContext';

const image = RENEWAL_IMAGES.pending_payment;

function FailedPaymentModal(props) {
  const {isOpen, toggleClose} = props;
  const {account} = useAuth();
  const {isLoading, onManage} = useManageSubscription(window.location.pathname);

  const isSuperAdmin =
    get(account, 'account_role') === ACCOUNT_ROLES.super_admin;

  return (
    <Modal isOpen={isOpen} toggle={toggleClose} backdrop="static" centered>
      <div className="position-absolute" style={{right: 20, top: 10}}>
        <h4
          onClick={toggleClose}
          className="text-secondary"
          style={{cursor: 'pointer'}}
        >
          &times;
        </h4>
      </div>
      <div>
        <img width="100%" height="100%" src={image} alt="Failed payment" />
      </div>
      <ModalBody className="p-4">
        <h4 className="font-weight-bold text-center ">
          You have pending payment
        </h4>
        <p
          className={cx({
            'mb-0': isSuperAdmin,
            'mb-3': !isSuperAdmin,
          })}
        >
          We tried to renew your plan but something went wrong. Please update
          your payment method to continue using the paid features.
        </p>

        {!isSuperAdmin && (
          <p className="mb-0">
            Kindly contact your super admin to update your payment method.
          </p>
        )}
      </ModalBody>
      {isSuperAdmin && (
        <ModalFooter>
          <Button
            outline
            tag={Link}
            to="/contact"
            color="primary"
            className="mr-2"
          >
            Contact Support
          </Button>
          <Button
            color="primary"
            onClick={() => onManage()}
            disabled={isLoading}
          >
            {isLoading && <MuiIcon name="autorenew" />}
            Update Payment Details
          </Button>
        </ModalFooter>
      )}
    </Modal>
  );
}

export default FailedPaymentModal;
